import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

// GenerateAcaoPrevCorretivaColumns 

type Props = {
  onActionEditar: (IdAcaoPrevCorretiva: number | null, openState: boolean, openAnalise: boolean, type: string) => void,
  onActionDeletar: (IdAcaoPrevCorretiva: number | null, openState: boolean, type: string) => void,
  isReadOnly: boolean;
};

export const GenerateAcaoPrevCorretivaColumns = ({
  onActionEditar,
  onActionDeletar,isReadOnly
}: Props): GridColDef[] => {
  return [
    {
      field: "Numero",
      filterable: false,
      headerName: "Nº",
      minWidth: 75,
      width: 75,
      sortable: false,
    },
    {
      field: "Descricao",
      filterable: false,
      headerName: "Ação",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "NomeFuncionarioResponsavel",
      filterable: false,
      headerName: "Responsável",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "DataPrevista",
      filterable: false,
      headerName: "Data Prevista",
      flex: 1,
      minWidth: 150,
      sortable: false,
       renderCell: (params) => {
        return (<span>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</span>);
      },
    },
    {
      field: "DataRealizado",
      filterable: false,
      headerName: "Data Realizada",
      flex: 1,
      minWidth: 150,
      sortable: false,
       renderCell: (params) => {
        return (<span>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</span>);
      },
    },
    {
      field: 'IdAcaoPrevCorretiva',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        if (isReadOnly) return null;
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, true, false, "P")}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true, "P")}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}